import LeDialog from './src';

// 为组件提供 install 安装方法，供按需引入
LeDialog.install = function(Vue) {
  Vue.component(LeDialog.name, LeDialog);
};

// 导出组件
export default LeDialog;
